import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}

    :host {
        display: block;
    }
`;
//# sourceMappingURL=debounced-input.styles.js.map